import { api } from '../api';
import { useLoad } from '../hooks';
import { stamp } from '../format';
import { Card, Empty, ErrorNote, Loading, StatusPill, Table } from '../components/ui';
import type { ActorSummary, Page } from '../types';

const SCOPE_TR: Record<string, string> = {
  SYSTEM: 'sistem',
  PRIVATE: 'özel',
  PUBLIC: 'genel',
};

/** Katalog. Salt okunur: actor'lar `pnpm actors:sync` ile gelir, hiçbir zaman arayüzden değil. */
export function Actors() {
  const actors = useLoad(() => api.get<Page<ActorSummary>>('/v1/actors?limit=100'));
  const rows = actors.data?.items ?? [];

  return (
    <Card
      title={`Actor'lar${rows.length ? ` (${rows.length})` : ''}`}
      flush
      footer="Yayınlanmış sürümler değişmezdir. Bir actor'ı değiştirmek için manifest sürümünü yükselt ve tekrar senkronize et."
    >
      {actors.error && (
        <div style={{ padding: '14px 16px 0' }}>
          <ErrorNote message={actors.error} />
        </div>
      )}
      {actors.loading && rows.length === 0 && <Loading />}
      {!actors.loading && rows.length === 0 && (
        <Empty title="Kayıtlı actor yok">
          Derlenmiş kayıt defterini yayınlamak için <code>pnpm actors:sync</code> çalıştır.
        </Empty>
      )}
      {rows.length > 0 && (
        <Table
          head={[
            'Slug',
            'Ad',
            'Varsayılan sürüm',
            'Çalışma zamanı',
            'Durum',
            'Kapsam',
            'Güncelleme',
          ]}
        >
          {rows.map((actor) => (
            <tr key={actor.slug}>
              <td className="mono cell-title">{actor.slug}</td>
              <td>
                {actor.name}
                {actor.description && <div className="muted small">{actor.description}</div>}
              </td>
              <td className="mono muted">{actor.defaultVersion?.version ?? '—'}</td>
              <td className="muted small">{actor.defaultVersion?.runtimeType ?? '—'}</td>
              <td>
                <StatusPill status={actor.status} />
              </td>
              <td className="muted small">{SCOPE_TR[actor.scope] ?? actor.scope}</td>
              <td className="muted small">{stamp(actor.updatedAt)}</td>
            </tr>
          ))}
        </Table>
      )}
    </Card>
  );
}
